import * as types from '../actions/actiontypes';
import initialState from './initialstate';

export default function isCurrentResourceAvailableReducer(state = initialState.isCurrentResourceAvailable, action) {
	switch (action.type) {
		case types.SET_IS_CURRENT_RESOURCE_AVAILABLE:
			return action.isCurrentResourceAvailable;
		default:
			return state;
	}
}